export default function filterNulls(array) {
    return array.filter((val) => val !== null && val !== undefined);
}
//# sourceMappingURL=filterNulls.js.map